module.exports = __webpack_public_path__ + "img/phoenix_kedel_2.cc1a0422.png";